let copySource = {
    document: {
        title:'Acquistate/Regalate punti'
    },
    headerNav:{
        logo:{
            alt:'Marriott Bonvoy',
            link:'https://www.marriott.com/default.mi'
        },
        home: {
            copy: 'Home',
            link: ''
        },
        buy: {
            copy:'Acquistate punti',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=it-IT&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=it-IT&iscid=points_buy_cta_em_pr'
        },
        gift: {
            copy:'Regalate punti',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=it-IT&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=it-IT&iscid=points_gift_cta_em_pr'
        },
        multiply: {
            copy:'Moltiplicate punti',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=it-IT&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=it-IT&iscid=points_multiply_plp_web_ev'
        },
        mr: {
            copy:'Marriott.com',
            link:'https://www.marriott.it/default.mi'
        }
    },
    hero: {
        lang: 'landing-it',
        headline: {
            lineOne: 'Punti per ogni desiderio. ',
            lineTwo: 'Acquistate ora, partite quando volete.',
        },
        subHeadline : 'Quando l’ispirazione arriva, dovete avere i punti giusti per\ntrasformarla in realtà. Per una vacanza gratificante o\nun’esperienza improvvisata, ci sono innumerevoli luoghi da\nvisitare e cose da fare. Acquistate o regalate punti adesso.',
        alt:'Acquistate punti, fate le valigie e partite. Prenotate un viaggio da non perdere. Trascorrete più notti in città. Questo è l’anno del “di più”: tutto è possibile con i punti Marriott Bonvoy®.'
    },
    promo: {
        hero: {
            promoLang: 'promo-it',
            headline: "Wonders of More",
            body:"Get closer to your next vacation with a 50% bonus on purchases of 2,000 or more points October 6–13.",
        }
    },
    ctas:{
        buy:{
            imgAlt:'Finestra della camera di un hotel con vista sul paesaggio urbano.',
            header:'Acquistate punti',
            copy:'Per aggiungere una notte in più al vostro soggiorno o per usufruire\n di un accesso VIP a uno spettacolo sold-out: acquistate subito i\n punti per essere pronti a tutto.',
            linkCopy:'Acquistate punti',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=it-IT&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=it-IT&iscid=points_buy_cta_em_pr'
        },
        gift:{
            imgAlt:"Balcone di un hotel con piscina che si affaccia sull’oceano.",
            header:'Regalate punti',
            copy:'Regalate punti ad amici e familiari, così potranno viaggiare come\n vogliono e ogni volta che lo desiderano.',
            linkCopy:'Regalate punti',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=it-IT&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=it-IT&iscid=points_gift_cta_em_pr'
        },
        multiply:{
            imgAlt:'Hotel balcony with a pool overlooking the ocean.',
            header:'Moltiplicate punti',
            copy:'Avete accumulato punti su un soggiorno recente? Ora potete acquistare fino a quattro volte i punti guadagnati con uno sconto per vivere alla grande il vostro prossimo viaggio.',
            linkCopy:'ACQUISTATE PUNTI CON SCONTI',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=it-IT&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=it-IT&iscid=points_multiply_plp_web_ev'
        },
        membership:{
            imgAlt:'',
            imgSrc: './images/mr_rebrand_register_Placeholder.png',
            header: 'Iscrivetevi al programma',
            link: 'https://www.marriott.com/it/loyalty/createAccount/createAccountPage1.mi?enrollmentSourceCode=MSPV',
            copy: 'Accedete a tariffe riservate ai soci, utilizzate i punti per usufruire di pernottamenti gratuiti e molto altro ancora. I nuovi soci possono acquistare i punti trenta (30) giorni dopo l’iscrizione al programma Marriott Bonvoy.'
        }
    },
    footer:{
        copyrightOne:"Questo sito web è gestito da Points.com Inc. per conto di Marriott International, Inc. per l'acquisto di Marriott Bonvoy Points in conformità con i ",
        copyrightLinkTC: 'https://points-ebgt.s3.amazonaws.com/marriott/terms-conditions/bonvoy-terms-and-conditions-IT-IT.html',
        copyrightTwo:'Termini e condizioni di Points.com Inc.',
        copyrightThree:" L'assegnazione e l'utilizzo di Marriott Bonvoy Points in relazione a una transazione di acquisto sono soggetti al ",
        copyrightLinkTwo: 'https://www.marriott.com/loyalty/terms/default.mi',
        copyrightFour:'Regolamento del programma Marriott Bonvoy',
        copyrightFive:" e all'",
        copyrightLinkThree: 'https://www.marriott.com/about/privacy.mi',
        copyrightSix:'Informativa sulla privacy',
        copyrightSeven:'.',

        options: {
            de: "Deutsch",
            es: "Español",
            en:'English',
            fr: 'Français',
            it: 'Italiano',
            jp:'日本語',
            pt:'Português',
            ch:'国际'
        },
        footerbar:{
            logo: "./images/bonvoy_logo.png",
            grp1: "LUXURY",
            grp2: "PREMIUM",
            grp3: "SELECT",
            grp4: "MIDSCALE",
            grp5: "LONGER STAYS"
        },
        langIconSrc: './images/Icon-Globe.svg',
        langIconAlt: 'Italiano',
        tracking:{
            doNotSell:{
                copy:'Non desidero che le mie informazioni personali siano vendute',
                href:'https://www.marriott.com/about/ccpa/do-not-sell.mi'
            },
            prefs: {
                copy:'Preferenze di tracciamento',
                href:'https://consent-pref.trustarc.com/?layout=gdpr&type=marriottgdpr&site=marriottgdpr.com&action=notice&country=ca&locale=en&behavior=implied&irm=undefined&from=https://consent.trustarc.com/'
            }
        },
        terms:{
            copy:'Condizioni di utilizzo',
            href:'https://www.marriott.it/about/terms-of-use.mi'
        },
        programTerms:{
            copy:'Termini e condizioni del programma',
            href:'https://www.marriott.it/loyalty/terms/default.mi'
        },
        privacy:{
            copy:'Centro per la privacy',
            href:'https://www.marriott.it/chi-siamo/informativa-sulla-privacy.mi'
        },
        accessibility:{
            copy:'Accessibilità digitale',
            href:'https://www.marriott.it/digital-accessibility.mi'
        },
        siteMap:{
            copy:'Mappa del sito',
            href:'https://www.marriott.it/sitemap.mi'
        },
        help:{
            copy:'Assistenza',
            href:'https://www.marriott.it/help/default.mi'
        },
    }
    
}

export default copySource



